import { render, staticRenderFns } from "./UpdateRequestAgree.vue?vue&type=template&id=5cc084dc&scoped=true&"
import script from "./UpdateRequestAgree.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc084dc",
  null
  
)

export default component.exports